import { useOnboardingStatus } from "./useOnboardingStatus";

export enum RouteGroup {
    ONBOARDING = "ONBOARDING",
    MAIN = "MAIN",
}

export function useRouteGroup(): RouteGroup {
    const isOnboarded = useOnboardingStatus();

    return isOnboarded ? RouteGroup.MAIN : RouteGroup.ONBOARDING;
}
